import React from 'react';

const Footer = () => (
    <footer className="footer">
      <div className="content has-text-centered">
        Created by
        <p>
          <strong>nije & muva co.</strong>
        </p>
      </div>
    </footer>
)

export default Footer;
